// This file is automatically generated. Do not edit manually.

import { t } from "i18next";

export const SafetyControlSurveyStateValues = ["CLOSED", "STARTED", "INITIAL"] as const;

export type SafetyControlSurveyState = (typeof SafetyControlSurveyStateValues)[number];

export const getSafetyControlSurveyStateLabels = () => ({
	CLOSED: t("closed"),
	STARTED: t("started"),
	INITIAL: t("initial"),
});

export const getSafetyControlSurveyStateLabel = (value: SafetyControlSurveyState): string => {
	return getSafetyControlSurveyStateLabels()[value];
};
